// extracted by mini-css-extract-plugin
export default {"flag":"flag_flag__7r1Cz","enter":"flag_enter__5vPJj"};